
import { Component, Vue, } from 'vue-property-decorator';
import { Store, } from '~/apps/account/store';
import FeedbackBox from '~/components/feedback-box/feedback-box.vue';
import HeaderText from '~/components/header-text/header-text.vue';
import PropertyAddress from '~/components/property-address/property-address.vue';
import Tooltip from '~/components/tooltip/tooltip.vue';
import { preventLeaveMixin, } from '~/mixins/prevent-leave-mixin';
import toFixed from '~/utils/toFixed';

@Component({
	components: {
		HeaderText,
		FeedbackBox,
		Tooltip,
		PropertyAddress,
	},
	metaInfo: {
		title: 'Digital billing - Check details - Southern Water',
	},
	methods: {
		toFixed,
	},
	mixins: [
		preventLeaveMixin,
	],
})
export default class RegisterationCheckDetailsPage extends Vue {
	customerLastName = this.customerDetails.customerLastName;
	customerNumber = this.customerDetails.customerNumber;
	customerEmail = this.customerDetails.customerEmail;
	property = this.registrationDetails.address;
	firstName = this.registrationDetails.customerBasicInfo.firstName;

	get customerDetails() {
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		return Store.state.register.customerDetails!;
	}

	get registrationDetails() {
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		return Store.state.register.registrationDetails!;
	}

	mounted() {
		Store.commit.register.setStep(2);
		sessionStorage.removeItem('digitalBillingEmailToken');
	}
}
